export enum Profile {
	Main = 1,
	Substitute = 2,
	Secretary = 3,
	Accounting = 4,
	Demo = 0,
	None = -1,
}